import React, { useContext } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import CreateOrder from './CreateOrder'
import { v4 as uuidv4 } from 'uuid'
import { LogoContext } from '../../contexts/LogoContext'
import { ColorContext } from '../../contexts/ColorContext'
import { NamePositionContext } from '../../contexts/NamePositionContext'

const stripePromise = loadStripe('pk_test_gOmZB0HZjP5ezaS7cITRzs1K00vX2K9RNB')

export default function StripeButton(props) {
  const { logos } = useContext(LogoContext)
  const { colors } = useContext(ColorContext)
  const { info } = useContext(NamePositionContext)

  const handleClick = async () => {
    const stripe = await stripePromise
    let clientId = uuidv4()

    let orderData = {
      name: props.name,
      description: props.description,
      currency: 'usd',
      quantity: 1,
      amount: props.amount,
      clientId
    }
    const headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'https://zoom-back.web.app'
    }
    CreateOrder(clientId, info, colors, logos, props.amount)

    fetch('https://us-central1-zoom-back.cloudfunctions.net/createOrderAndSession', {
      method: 'POST',
      body: JSON.stringify(orderData),
      headers
    }).then(response => {
      return response.json()
    }).then(data => {
      var body = JSON.parse(data.body)
      return body.sessionId
    }).then(sessionId => {
      stripe.redirectToCheckout({
        sessionId: sessionId
      }).then(function (result) {
        if (result.error) {
          console.log(result.error.message)
        }
      })
    })
  }

  return (
    <button role="link" onClick={handleClick}>
      {props.label}
    </button>
  )
}
